import React from 'react';

import { Container, Title, Subtitle, BgImage } from './styles';
interface Props {
  title: string;
  subtitle: string;
}

const ErrorMessage = ({ title, subtitle }: Props) => (
  <Container>
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
    <BgImage></BgImage>
  </Container>
);

export default ErrorMessage;
